import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowLeftFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM6.78836 11.9874C6.78836 11.7975 6.86584 11.6473 7.04692 11.4661L10.5591 7.93887C10.688 7.81867 10.839 7.75468 11.0318 7.75468C11.4105 7.75468 11.6904 8.03859 11.6904 8.40483C11.6904 8.59773 11.6003 8.77018 11.4763 8.89038L10.0594 10.3078L8.81583 11.3808L10.8295 11.308H16.554C16.954 11.308 17.233 11.592 17.233 11.9913C17.233 12.3788 16.9579 12.6667 16.554 12.6667H10.8295L8.81102 12.5979L10.0594 13.6756L11.4763 15.0844C11.609 15.2046 11.6904 15.377 11.6904 15.5699C11.6904 15.9361 11.4105 16.2288 11.0318 16.2288C10.839 16.2288 10.688 16.1561 10.5591 16.0359L7.04692 12.5173C6.87845 12.3488 6.78836 12.1938 6.78836 11.9874Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowLeftFilledSvg };
